export const header = {
  TITLE: 'Free Child Support Calculator',
  DESCRIPTION: 'This is a free tool to help you estimate how much child support you or your co-parent may need to pay monthly. To get a more accurate number, choose the Full Calculator button below.'
};

export const sectionIds = {
  PARENTS_AND_CHILDREN: 'PARENTS_AND_CHILDREN',
  WAGES_AND_SALARIES: 'WAGES_AND_SALARIES',
  TIME_WITH_PARENTS: 'TIME_WITH_PARENTS',
  TAX_ESTIMATOR: 'TAX_ESTIMATOR',
  EXPENSES: 'EXPENSES'
};

export const sectionTitles = {
  PARENTS_AND_CHILDREN: 'Parents and children',
  WAGES_AND_SALARIES: 'Wages and salaries',
  TIME_WITH_PARENTS: 'Time with parents',
  TAX_ESTIMATOR: 'Tax estimator',
  EXPENSES: 'Expenses'
};

export const sectionDescriptions = {
  PARENTS_AND_CHILDREN: 'For this section, only include children from your relationship together who are 18 years old or less, or who have special needs.',
  WAGES_AND_SALARIES: "When listing each parent's income, use the gross income. This is the total amount of wages, salary, and tips you make per month before any taxes are taken out, and can usually be found on a W2 or 1099 tax form.",
  TIME_WITH_PARENTS: 'Now, estimate the total amount of time the children spend with each parent. For a list of common parenting schedules, click here.',
  TAX_ESTIMATOR: 'This section allows for federal and state tax estimates for each parent. Move the slider to estimate each parent’s tax bracket.',
  EXPENSES: 'For this section, please indicate how much each parent has to pay for expenses. If a parent does not have the listed expense, leave it at $0. For more information about why only these expenses are listed, see the Child Support Expenses link.'
};

export const parentsSectionQuestions = {
  '1': 'What is one parent’s name?',
  '2': 'What is the other parent’s name?',
  '3': 'How many children under 18 (or special needs children) do you share?',
  '4': 'What is the first (oldest) child’s name?',
  '5': 'Is time spent with an individual parent the same for all children?'
};

export const taxEstimatorQuestions = (name) => {
  return ({
    FEDERAL: `What is ${name}’s approximate federal tax rate?`,
    STATE: `What is ${name}’s approximate California state tax rate?`
  })
};

export const wagesQuestions = (name) => {
  return (
    `What is ${name}’s gross income?`
  )
};

export const wagesIds = {
  HOURLY : 'HOURLY',
  WEEKLY : 'WEEKLY',
  BIWEEKLY : 'BIWEEKLY',
  SEMIMONTHLY : 'SEMIMONTHLY',
  MONTHLY : 'MONTHLY',
  ANUALLY : 'ANNUALLY', 
  YEARTODATE : 'YEARTODATE'  
};


export const wagesOptions = {
  HOURLY : {id: 'HOURLY' , label:'hourly', index:0, value:0 },
  WEEKLY :{id: 'WEEKLY' ,label:'weekly', index:1, value:1 },
  MONTHLY :{id: 'MONTHLY' ,label:'monthly', index:2, value:2 },
  BIWEEKLY :{id: 'BIWEEKLY' ,label:'twice per month', index:3, value:3 },
  SEMIMONTHLY :{id: 'SEMIMONTHLY' ,label:'every two weeks' , index:4 , value:4 },
  ANNUALLY :{id: 'ANNUALLY' ,label:'annually', index:5, value:5 },
  YEARTODATE :{id: 'YEARTODATE' ,label:'year-to-date', index:6, value:6 },
};


export const timeParentsQuestions = (name) => {
  return ({
    EQUAL: `What amount of time do the children spend with ${name}?`,
    NOT_EQUAL: `What amount of time does this child spend with ${name}?`
  })
};


export const timeParentsOptions = [
  {label:'% (percent)', maxValue: 100 , index: 0,  value: 0 },
  {label:'hours per week', maxValue: 168 , index: 1, value: 1 },
  {label:'days per week', maxValue: 7 , index: 2, value: 2},
  {label:'hours per two weeks', maxValue: 336 , index: 3, value: 3 },
  {label:'days per two weeks', maxValue: 14 , index: 4, value: 4 },
  {label:'days per year', maxValue: 365 , index: 5, value: 5 },
];

export const yesNoOptions = [
  {label: 'Yes', value:true},
  {label: 'No', value:false}
];

export const ordinals = [
  'first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth'
];

export const taxSteps = {
  FEDERAL: [10, 12, 22, 24, 32, 35, 37],
  STATE: [1, 2, 4, 6, 8, 9.3, 10.3, 11.3, 12.3],
};